import { render } from "./compare-gaji-import-excel.vue?vue&type=template&id=9ad18502"
import script from "./compare-gaji-import-excel.vue?vue&type=script&lang=js"
export * from "./compare-gaji-import-excel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__